import React, { useEffect } from "react";
import ApexCharts from "apexcharts";
import _ from "lodash";
import { Box } from "@material-ui/core";

export function Graph({ graphData }) {
  useEffect(() => {
    const rows = graphData;
    const element = document.getElementById("graphDiv");
    const chart = new ApexCharts(element, {
      chart: {
        type: "donut",
      },
      series: rows.map((d) => d.score),
      labels: rows.map((d) => d.area),
      legend: {
        show: true,
        position: "bottom",
        fontSize: "20px",
      },
      plotOptions: {
        pie: {
          customScale: 0.8,
        },
      },
      colors: [
        "rgba(231, 76, 60, 1)",
        "rgba(60, 115, 168,1)",
        "rgba(255, 205, 2, 1)",
        "rgba(13, 172, 80,1)",
        "rgba(154, 18, 179,1)",
        "rgba(243, 156, 18,1)",
      ],
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          return Math.round((_.sum(opts.w.globals.series) * val) / 100);
        },
        style: {
          fontSize: "140px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: "bold",
        },
      },
    });
    chart.render();
  }, []);
  return <Box id="graphDiv"></Box>;
}
